export default from './following-page';



// WEBPACK FOOTER //
// ./app/containers/following-page/index.js